import { createFileRoute } from '@tanstack/react-router';

import { LinkageMenu } from '../../components/LinkageMenu/LinkageMenu';

export const Route = createFileRoute('/_auth/linkage-menu')({
  component: LinkageMenu,
});
